var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111.03125 114.81479",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-301.62 -417.81)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m374.41 510.02c-0.0421 3.9189 3.2186 7.1359 6.7618 7.737 3.7844 0.77575 8.1594-1.1188 9.7143-4.964 1.1772-2.8314 0.32113-6.3059-1.8923-8.2986-3.5294-3.3852-9.6472-3.1333-12.8 0.68979-1.1086 1.3037-1.7801 3.0152-1.7838 4.771",
    fill: "#ccc",
    stroke: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.76 506.67c-0.0421 3.9189 3.2186 7.1359 6.7618 7.737 3.7844 0.77575 8.1594-1.1188 9.7143-4.964 1.1772-2.8313 0.32113-6.3059-1.8923-8.2986-3.5294-3.3852-9.6472-3.1333-12.8 0.68979-1.1086 1.3037-1.7801 3.0152-1.7838 4.771",
    fill: "#fff",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.64 525.77c-0.0501 2.8537 2.3334 5.399 5.1255 5.7785 2.7999 0.48073 5.8829-1.1295 6.8245-3.8607 0.92041-2.4169-0.1005-5.325-2.2699-6.7044-2.384-1.6416-5.8886-1.3699-7.9316 0.70305-1.0866 1.0469-1.7547 2.5202-1.7484 4.0355",
    fill: "#ccc",
    stroke: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.14 523.27c-0.0501 2.8537 2.3334 5.399 5.1255 5.7785 2.7999 0.48073 5.8829-1.1295 6.8245-3.8607 0.92041-2.4169-0.1005-5.325-2.2699-6.7044-2.384-1.6416-5.8886-1.3699-7.9316 0.70305-1.0866 1.0469-1.7547 2.5202-1.7484 4.0355",
    fill: "#fff",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.71 423.81c8.0639 0 15.223 3.5673 19.776 9.0873 3.0025-2.8728 6.9985-4.6229 11.372-4.6229 6.9499 0 12.897 4.4052 15.494 10.719 10.212 0.61452 18.303 8.5222 18.303 18.197 0 7.1313-4.3851 13.293-10.783 16.294 0.0668 0.64258 0.11326 1.2886 0.11326 1.9489 0 10.322-8.3709 18.696-18.688 18.696-3.382 0-6.5512-0.92057-9.2876-2.4928-4.1566 5.7998-11.203 9.6085-19.187 9.6085-10.007 0-18.524-6.0059-21.746-14.39-2.1153 0.68143-4.3692 1.0424-6.7052 1.0424-12.283 0-22.245-10.173-22.245-22.707v-0.18129c0.0914-11.371 8.3686-20.727 19.096-22.276 2.1356-10.774 12.29-18.922 24.487-18.922z",
    fill: "#ccc",
    stroke: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.21 418.81c8.0639 0 15.223 3.5673 19.776 9.0873 3.0025-2.8728 6.9985-4.6229 11.372-4.6229 6.9499 0 12.897 4.4052 15.494 10.719 10.212 0.61452 18.303 8.5222 18.303 18.197 0 7.1313-4.3851 13.293-10.783 16.294 0.0668 0.64258 0.11326 1.2886 0.11326 1.9489 0 10.322-8.3709 18.696-18.688 18.696-3.382 0-6.5512-0.92057-9.2876-2.4928-4.1566 5.7998-11.203 9.6085-19.187 9.6085-10.007 0-18.524-6.0059-21.746-14.39-2.1153 0.68143-4.3692 1.0424-6.7052 1.0424-12.283 0-22.245-10.173-22.245-22.707v-0.18129c0.0914-11.371 8.3686-20.727 19.096-22.276 2.1356-10.774 12.29-18.922 24.487-18.922z",
    fill: "#fff",
    stroke: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.94254e9b63867bb9bf01a04ba6e469c1.svg";
export { ForwardRef as ReactComponent };